// src/App.jsx
import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";
import RequireKycApproved from "./RequireKycApproved";
import { Preloader } from "./components";
import ScrollToTop from "./helpers/scroll-top";
import { DefaultLayout } from "./layouts";

// AUTH (public)
import { SignIn, SignUp, ForgotPassword, ResetPassword } from "./pages";

// PRIVATE PAGES
import {
  Project,                 // /l/project
  ProjectFunding,          // /f/project
  ProjectDetails,          // /l/project/:id
  ProjectFundingDetails,   // /f/project/:id
  Ideation,
  Funding,
  IdeationSummary,
  FundingSummary,
  Transaction,
  LogDetail,
  Log,
  KycAdd,
  KycSubmitted,
  Dashboard,
  Profile,
  EditProfile,
  Notification,
  NotFound,
} from "./pages";

function App() {
  return (
    <Router basename={import.meta.env.BASE_URL}>
      <ScrollToTop>
        <Suspense fallback={<Preloader />}>
          <Routes>
            {/* public */}
            <Route path="/" element={<Navigate to="/sign-in" replace />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            {/* private (all URLs remain absolute in the browser; we use relative child paths) */}
            <Route element={<PrivateRoute />}>
              <Route element={<DefaultLayout />}>
                {/* dashboard & user */}
                
                <Route path="profile" element={<Profile />} />
                <Route path="edit-profile" element={<EditProfile />} />
                <Route path="notification" element={<Notification />} />
                <Route path="kyc/add" element={<KycAdd />} />
                <Route path="/kyc/submitted" element={<KycSubmitted />} />

                {/* project flows */}
                <Route element={<RequireKycApproved />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="l/project" element={<Project />} />
                <Route path="l/project/:id" element={<ProjectDetails />} />
                <Route path="f/project" element={<ProjectFunding />} />
                <Route path="f/project/:id" element={<ProjectFundingDetails />} />
                <Route path="ideation" element={<Ideation />} />
                <Route path="funding" element={<Funding />} />
                <Route path="interested/:id" element={<IdeationSummary />} />
                <Route path="invested/:id" element={<FundingSummary />} />
                <Route path="transaction" element={<Transaction />} />
                <Route path="log" element={<Log />} />
                <Route path="log/:id" element={<LogDetail />} />
                </Route>

                {/* 404 inside layout */}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>

            {/* safety: legacy redirect for old /editprofile -> /edit-profile */}
            <Route path="/editprofile" element={<Navigate to="/edit-profile" replace />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
}

export default App;
